import { render, staticRenderFns } from "./TeamUae.vue?vue&type=template&id=8a2b4a00"
import script from "./TeamUae.vue?vue&type=script&lang=js"
export * from "./TeamUae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports